import styled from 'styled-components';

export type ImageProps = {
  media: string;
  isMediaComment?: boolean;
};

const Image = styled.img`
  max-width: 480px;
  display: block;
  margin: auto;
`;

Image.displayName = 'Image';

const ImageComment = styled.img`
  width: 9.438rem;
  height: 6.292rem;
`;

ImageComment.displayName = 'ImageComment';

export const ImagePreview = ({ media, isMediaComment = false }: ImageProps) => {
  return (
    <>
      {isMediaComment ? (
        <ImageComment src={media} className="_d-block _rounded-lg" loading="lazy" />
      ) : (
        <Image data-test="image-preview" src={media} className="_w-full _h-full" loading="lazy" />
      )}
    </>
  );
};
